import { render } from "./loading-spinner.vue?vue&type=template&id=c0c172f0&scoped=true"
import script from "./loading-spinner.vue?vue&type=script&lang=js"
export * from "./loading-spinner.vue?vue&type=script&lang=js"

import "./loading-spinner.vue?vue&type=style&index=0&id=c0c172f0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c0c172f0"

export default script